// frontend/src/admin/blockforms/VideoForm.js
import React, { useState, useEffect } from 'react';
import { buildBlockSave } from './blockSaveTarget';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://80.225.197.31:8001';


const VideoForm = ({ level, entityId,section, editingBlock, nextOrderIndex, onSaved, onCancel }) => {
    const existing = editingBlock?.content_data || {};

    const [videoUrl, setVideoUrl] = useState(existing.video_url || '');
    const [orientation, setOrientation] = useState(existing.orientation || 'horizontal');
    
    const [captionEn, setCaptionEn] = useState(existing.en?.caption || '');
    const [captionHi, setCaptionHi] = useState(existing.hi?.caption || '');
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const handleBeforeUnload = (e) => {
            e.preventDefault();
            e.returnValue = '';
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [videoUrl, captionEn, captionHi]);
    
    
    const handleSave = async () => {
        if (!videoUrl.trim()) {
            setError('Please enter a video URL');
            return;
        }
        setError(null);
        setSaving(true);

        const content_data = {
            video_url: videoUrl,
            orientation,
            en: { caption: captionEn }
        };
        if (captionHi) {
            content_data.hi = { caption: captionHi };
        }

        const { url, method, payload } = buildBlockSave({
            level, entityId, section, editingBlock,
            blockType: 'video',
            contentData: content_data,
            orderIndex: nextOrderIndex,
        });

        try {
            const res = await fetch(url, {
                method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (!res.ok) {
                const err = await res.json();
                throw new Error(err.detail || 'Save failed');
            }
            onSaved();
        } catch (err) {
            setError(err.message);
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="ace-form">
            <h4>{editingBlock ? 'Edit' : 'Add'} Video</h4>
            {error && <div className="ace-error">{error}</div>}

            <label>Video URL (YouTube) *</label>
            <input type="text" value={videoUrl} onChange={(e) => setVideoUrl(e.target.value)} placeholder="https://youtube.com/watch?v=..." />

            <label>Video Orientation</label>
            <select value={orientation} onChange={(e) => setOrientation(e.target.value)}>
                <option value="horizontal">Horizontal (landscape)</option>
                <option value="vertical">Vertical (portrait / Shorts)</option>
            </select>
            
            <label>Caption (English)</label>
            <input type="text" value={captionEn} onChange={(e) => setCaptionEn(e.target.value)} />

            <label>Caption (Hindi, optional)</label>
            <input type="text" value={captionHi} onChange={(e) => setCaptionHi(e.target.value)} />

            <div className="ace-form-actions">
                <button onClick={handleSave} disabled={saving}>{saving ? 'Saving...' : 'Save'}</button>
                <button onClick={onCancel} className="ace-cancel-btn">Cancel</button>
            </div>
        </div>
    );
};

export default VideoForm;